module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "extra"
  }, [_c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    })
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.formattedDate))]), _vm._v(" "), (_vm.extra.topics) ? _c('span', [_vm._v("• \n        "), _vm._l((_vm.extra.topics), function(topic, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Extras',
          query: {
            topic: topic.slug
          }
        }
      },
      domProps: {
        "innerHTML": _vm._s(topic.name)
      }
    }), (index + 1 !== _vm.extra.topics.length) ? _c('span', [_vm._v(", ")]) : _vm._e()], 1)
  })], 2) : _vm._e()]), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.extra.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), (_vm.index === 6) ? _c('v-waypoint', {
    on: {
      "waypoint": _vm.$parent.handleScroll
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba40188"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/extras/Extra.vue
// module id = 775
// module chunks = 1